<template>
  <div class="mb-2 row free-play-area">
    <div class="title col-6">
      <custom-switch id="free_play" :value="activeFreeBet" @change="changeFreePlay" :text="text"></custom-switch>
    </div>
    <div class="title col-6 ta-right">({{ $t('BetSlip.AvailableFreePlay', [balance.free_play]) }})</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      freePlay: false,
    };
  },
  watch: {
    freePlay(value) {
      this.updateBetFreeWager(value ? 1 : 0);
    },
  },
  computed: {
    ...mapState({
      balance: state => state.player.balance,
      activeFreeBet: state => state.betSlip.activeFreeBet,
    }),
    text() {
      return this.$t('BetSlip.FreePlay');
    },
  },
  methods: {
    ...mapActions({
      updateBetFreeWager: 'betSlip/updateBetFreeWager',
    }),
    changeFreePlay() {
      this.freePlay = !this.freePlay;
    },
  },
  mounted() {
    this.freePlay = this.activeFreeBet;
  },
};
</script>
